const dateFormatter = new Intl.DateTimeFormat('ru-RU', {
  day: '2-digit',
  month: '2-digit',
  year: 'numeric',
});

export function formatTimestamp(timestamp?: number | null) {
  if (!timestamp || isNaN(timestamp)) {
    return '';
  }
  return dateFormatter.format(new Date(timestamp * 1000));
}
